'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlideType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _react3 = require('swiper/react');

require('swiper/css');

require('swiper/css/navigation');

require('swiper/css/pagination');

var _swiper = require('swiper');

var _sanitize_utility = require('../../../../packages/common-utilities/src/sanitize_utility');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _ramda = require('ramda');

var _fund_video = require('../fund_video');

var _fund_video2 = _interopRequireDefault(_fund_video);

var _functional_utility = require('../../../../packages/common-utilities/src/functional_utility');

var _tracking_utility = require('../../../../packages/common-utilities/src/tracking_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Carousel = function (_React$Component) {
  _inherits(Carousel, _React$Component);

  function Carousel(props) {
    _classCallCheck(this, Carousel);

    var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.setTallestHeight = function () {
      var tallestSlideHeight = Array.from(_this.getSlideRef().current.querySelectorAll('.swiper-slide')).reduce(function (prev, cur) {
        return cur.clientHeight > prev ? cur.clientHeight : prev;
      }, 0);
      var headerHeight = _this.getSlideRef().current.querySelector('h2.sub-header-2').clientHeight;
      var heightDiff = _this.props.breakpoint < 3 ? 1.2 : 1.1;
      _this.setState({
        minHeight: tallestSlideHeight * heightDiff,
        navTop: tallestSlideHeight / 2 + headerHeight + 16
      }, function () {
        Array.from(_this.getSlideRef().current.querySelectorAll('.swiper-slide')).forEach(function (ele) {
          return ele.style.height = _this.props.autoHeight ? tallestSlideHeight + 'px' : 'inherit';
        });
        Array.from(_this.getSlideRef().current.querySelectorAll('#why-choose-this-trust-container')).forEach(function (ele) {
          ele.style.height = _this.props.autoHeight ? tallestSlideHeight + 'px' : 'inherit';
          Array.from(ele.querySelectorAll("a")).forEach(function (aLink) {
            return aLink.addEventListener("click", _this.handleAnchorClick(aLink));
          });
        });
        Array.from(_this.getSlideRef().current.querySelectorAll('#video-with-description-container')).forEach(function (ele) {
          return ele.style.height = _this.props.autoHeight ? tallestSlideHeight + 'px' : 'inherit';
        });
      });
    };

    _this.getSlideTemplate = function () {
      var _SlideType$QUOTE$Slid;

      var slide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var getDefaultStyling = function getDefaultStyling(fontWeight, lineHeight) {
        return {
          fontWeight: fontWeight,
          lineHeight: lineHeight + 'px'
        };
      };
      var quoteContentStyling = _extends({}, getDefaultStyling(300, 40), {
        padding: '10px'
      });
      var quoteFooterStyling = _extends({}, getDefaultStyling(300, 32), {
        padding: '10px'
      });
      var flexContainerStyling = {
        height: '100%',
        display: 'flex',
        alignItems: 'center'
      };
      var isMobileView = _this.props.breakpoint < 3;
      var videoFlexContainerStyling = {
        height: isMobileView ? '50%' : '100%',
        display: isMobileView ? 'contents' : 'flex',
        alignItems: 'center'
      };
      var whyLeftColumnStyling = _extends({}, getDefaultStyling(400, 45), {
        padding: isMobileView ? '25px 10px' : '0 20px 0 10px'
      });
      var whyRightColumnStyling = _extends({}, getDefaultStyling(300, 24), {
        padding: isMobileView ? '15px 5px 0 10px' : '15px 5px 0 0'
      });
      var videoTextStyling = _extends({}, getDefaultStyling(300, 24), {
        padding: '0'
      });
      if (slide.slideType === SlideType.VIDEO_WITH_DESCRIPTION) {
        _this.hasVideoSlide = true;
      }
      return (_SlideType$QUOTE$Slid = {}, _defineProperty(_SlideType$QUOTE$Slid, SlideType.QUOTE, _react2.default.createElement(
        'div',
        { style: slide.templateContainerStyling || flexContainerStyling, id: 'quote-container' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('div', {
            'data-testid': 'carousel-slide-quote-text',
            style: quoteContentStyling,
            className: 'sub-header-3',
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer('"' + slide.quoteText + '"') }
          }),
          _react2.default.createElement('div', {
            'data-testid': 'carousel-slide-quote-author',
            style: quoteFooterStyling,
            className: 'category',
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(slide.quoteAuthor) }
          })
        )
      )), _defineProperty(_SlideType$QUOTE$Slid, SlideType.WHY_CHOOSE_THIS_TRUST, _react2.default.createElement(
        'div',
        { style: slide.templateContainerStyling || {}, id: 'why-choose-this-trust-container' },
        _react2.default.createElement(
          'div',
          { style: videoFlexContainerStyling, className: 'col-xs-12 col-sm-12 col-xs-11 col-sm-11 col-sm-5 col-md-5 col-lg-5 col-xlg-5 padding-20' },
          _react2.default.createElement('h4', {
            'data-testid': 'carousel-slide-why-choose-this-trust-subtitle',
            style: whyLeftColumnStyling,
            className: 'header-2',
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(slide.subtitleTextBlock) }
          })
        ),
        _react2.default.createElement(
          'div',
          { style: videoFlexContainerStyling, className: 'col-xs-12 col-sm-12 col-xs-11 col-sm-11 col-sm-7 col-md-7 col-lg-7 col-xlg-7 padding-20' },
          _react2.default.createElement('div', {
            'data-testid': 'carousel-slide-why-choose-this-trust-text',
            className: 'caption',
            style: whyRightColumnStyling,
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(slide.rtfTextBlock) }
          })
        )
      )), _defineProperty(_SlideType$QUOTE$Slid, SlideType.VIDEO_WITH_DESCRIPTION, _react2.default.createElement(
        'div',
        { style: slide.templateContainerStyling || {}, id: 'video-with-description-container' },
        _react2.default.createElement(
          'div',
          { style: videoFlexContainerStyling, className: 'col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 ' + (isMobileView ? ' padding-top-20' : '') },
          _react2.default.createElement(_fund_video2.default, {
            videoWrapperStyle: {
              width: '100%'
            },
            fundVideo: {
              mediaId: slide.mediaId || slide.uploadVideo,
              mediaPlayerId: slide.mediaPlayerId || slide.videoMediaPlayerKey,
              mediaPlayerKey: slide.mediaPlayerKey || 'D624NUCYF',
              mediaType: slide.mediaType || "Single",
              title: slide.videoTitle
            },
            additionalVideoContainerWrapperClassNames: isMobileView ? ['padding-bottom-0', 'padding-top-20'] : [],
            additionalVideoContainerClassNames: ['carousel'],
            window: _this.props.window })
        ),
        _react2.default.createElement(
          'div',
          { style: videoFlexContainerStyling, className: 'col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xlg-7 padding-20' },
          _react2.default.createElement('div', {
            'data-testid': 'carousel-slide-video-with-description-text',
            className: 'caption',
            style: videoTextStyling,
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(slide.videoDescription) }
          })
        )
      )), _defineProperty(_SlideType$QUOTE$Slid, SlideType.IMAGE_WITH_DESCRIPTION, _react2.default.createElement(
        'div',
        { style: slide.templateContainerStyling || {}, id: 'image-with-description-container' },
        _react2.default.createElement(
          'div',
          { style: videoFlexContainerStyling, className: 'col-xs-12 col-sm-12 col-xs-11 col-sm-11 col-md-6 col-lg-6 col-xlg-6 ' + (isMobileView ? ' padding-top-20' : '') },
          _react2.default.createElement('img', { className: isMobileView ? 'margin-bottom-20 margin-top-20' : '',
            alt: slide.imageDescription,
            'data-testid': 'image-with-description-url',
            src: slide.uploadImage })
        ),
        _react2.default.createElement(
          'div',
          { style: videoFlexContainerStyling, className: 'col-xs-12 col-sm-12 col-xs-11 col-sm-11 col-md-6 col-lg-6 col-xlg-6 padding-20' },
          _react2.default.createElement('div', {
            'data-testid': 'carousel-slide-image-with-description-text',
            className: 'caption body2',
            style: videoTextStyling,
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(slide.imageDescription) }
          })
        )
      )), _SlideType$QUOTE$Slid)[slide.slideType];
    };

    _this.getNavStyling = function () {
      var extra = _this.props.navStyling || {};
      return _extends({
        top: _this.state.navTop || 260
      }, extra);
    };

    _this.getPaginationStyling = function () {
      return _this.props.paginationStyling || {
        "--swiper-pagination-color": "#000",
        "--swiper-pagination-bullet-inactive-color": "#FFF",
        "--swiper-pagination-bullet-inactive-opacity": "1",
        "--swiper-pagination-bullet-size": "16px",
        "--swiper-pagination-bullet-horizontal-gap": "4px"
      };
    };

    _this.pauseAllVideos = function () {
      if (_this.hasVideoSlide && (0, _functional_utility.pathOrNull)(['current', 'querySelectorAll'], _this.getSlideRef())) {
        Array.from(_this.getSlideRef().current.querySelectorAll('.swiper video')).forEach(function (video) {
          return video.pause();
        });
      }
    };

    _this.onSlideChange = function () {
      var swiperSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var index = swiperSlide.realIndex;
      if (index === undefined || !_this.props.slides[index]) {
        index = 0;
      }
      if (_this.props.slides[index].onSlideChange) {
        _this.props.slides[index].onSlideChange();
      }
      _this.pauseAllVideos();
      _this.setState({
        currentSlideIndex: index || 0
      });
      if (_this.props.headerContent) {
        return;
      }
      _this.setState({
        headerContent: _this.props.slides[index].headerContent || ''
      });
    };

    _this.trackCTAEvents = function (e, anchorElement, currentSlide) {
      if (!currentSlide || !anchorElement) {
        return;
      }
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      _tracking_utility.TrackingUtility.trackEvent({
        'event': 'gaEvent',
        'eventCategory': 'carousel',
        'eventAction': currentSlide.slideType + ' - ' + _this.getSubTitle(currentSlide) + ' - ' + anchorElement.textContent,
        'eventLabel': ' from: ' + window.location.href
      });
    };

    _this.trackNavEvents = function (e, isNext, self) {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      var prevIdx = self.state.currentSlideIndex + (isNext ? -1 : 1);
      if (prevIdx < 0) {
        prevIdx = self.props.slides.length - 1;
      } else if (prevIdx >= self.props.slides.length) {
        prevIdx = 0;
      }
      var currentSlide = self.props.slides[prevIdx];
      _tracking_utility.TrackingUtility.trackEvent({
        'event': 'gaEvent',
        'eventCategory': 'carousel',
        'eventAction': self.getSubTitle(currentSlide) + ' - ' + (isNext ? 'Next' : 'Previous'),
        'eventLabel': ' from: ' + window.location.href
      });
    };

    _this.getSubTitle = function (currentSlide) {
      if (!currentSlide) {
        return '';
      }
      return currentSlide.subtitleTextBlock || currentSlide.quoteText || currentSlide.videoTitle || currentSlide.uploadVideo;
    };

    if (!props.slides || props.slides.length < 1) {
      return _possibleConstructorReturn(_this);
    }
    _this.slideRef = _react2.default.createRef();
    _this.getSlideRef.bind(_this);
    _this.getSwiperTemplates.bind(_this);
    _this.getSwiper.bind(_this);
    _this.getSwiperSlide.bind(_this);
    _this.state = {
      headerContent: props.slides[0].headerContent,
      minHeight: _this.props.minHeight || _this.props.height || 300,
      currentSlideIndex: 0
    };
    return _this;
  }

  _createClass(Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoHeight) {
        this.setTallestHeight();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.pauseVideos) {
        this.pauseAllVideos();
      }
    }
  }, {
    key: 'getSlideRef',
    value: function getSlideRef() {
      return this.slideRef;
    }
  }, {
    key: 'handleAnchorClick',
    value: function handleAnchorClick(aLink) {
      var _this2 = this;

      return function (e) {
        e.preventDefault();
        _this2.trackCTAEvents(e, aLink, _this2.props.slides[_this2.state.currentSlideIndex]);
        if (e.target.target === '_blank') {
          window.open(e.target.href);
        } else {
          window.location.href = e.target.href;
        }
        return false;
      };
    }
  }, {
    key: 'getSwiperTemplates',
    value: function getSwiperTemplates() {
      var _this3 = this;

      return this.props.slides.map(function (slide) {
        return {
          slide: slide,
          template: _this3.getSlideTemplate(slide)
        };
      }).filter(function (slideTemplate) {
        return !!slideTemplate.template;
      }).map(this.getSwiperSlide);
    }
  }, {
    key: 'getSwiperSlide',
    value: function getSwiperSlide(slideTemplate, index) {
      return _react2.default.createElement(
        _react3.SwiperSlide,
        {
          key: 'carousel-' + slideTemplate.slide.slideType + '-' + index,
          'data-testid': 'carousel-' + index
        },
        slideTemplate.template
      );
    }
  }, {
    key: 'getSwiper',
    value: function getSwiper(fixedHeight, paginationStyling, swiperTemplates) {
      return _react2.default.createElement(
        _react3.Swiper,
        {
          style: _extends({
            width: '80%',
            marginBottom: '5px',
            height: this.state.minHeight
          }, fixedHeight, paginationStyling),
          modules: [_swiper.Navigation, _swiper.Pagination],
          autoHeight: !!this.props.autoHeight,
          spaceBetween: this.props.spaceBetween,
          slidesPerView: this.props.slidesPerView,
          allowTouchMove: false,
          pagination: {
            clickable: false,
            bulletClass: 'swiper-pagination-bullet border-all-1',
            horizontalClass: 'bottom-0'
          },
          navigation: { prevEl: '.carousel-nav-prev', nextEl: '.carousel-nav-next', clickable: true },
          loop: this.props.loop,
          onSlideChange: this.onSlideChange
        },
        swiperTemplates
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      if (!this.props.slides || this.props.slides.length < 1) {
        return null;
      }
      var fixedHeight = this.props.autoHeight ? {} : {
        height: this.props.height + 'px'
      };
      var headerPadding = this.props.breakpoint > 2 ? 'padding-horizontal-30' : 'padding-horizontal-16';
      var swiperTemplates = this.getSwiperTemplates();
      if ((0, _ramda.isEmpty)(swiperTemplates)) {
        return null;
      }
      var navPadding = this.props.breakpoint < 3 ? 40 : 80;
      var paginationStyling = this.getPaginationStyling();
      return _react2.default.createElement(
        'div',
        {
          ref: this.getSlideRef(),
          'data-testid': 'carousel-slide-container',
          className: 'position-relative carousel-slide-container',
          style: this.props.slidesContainerStyling || {}
        },
        _react2.default.createElement('h2', {
          'data-testid': 'carousel-slide-header',
          className: headerPadding + ' sub-header-2 padding-bottom-20 padding-top-10 border-bottom-1 border-card-title-border margin-bottom-20',
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.headerContent || this.state.headerContent) }
        }),
        this.getSwiper(fixedHeight, paginationStyling, swiperTemplates),
        _react2.default.createElement('span', { onClick: function onClick(e) {
            return _this4.trackNavEvents(e, false, _this4);
          }, style: this.getNavStyling(), 'data-testid': 'carousel-nav-prev', className: 'icon-nav-right carousel-nav-prev padding-right-' + navPadding + ' reverse' }),
        _react2.default.createElement('span', { onClick: function onClick(e) {
            return _this4.trackNavEvents(e, true, _this4);
          }, style: this.getNavStyling(), 'data-testid': 'carousel-nav-next', className: 'icon-nav-right carousel-nav-next padding-left-' + navPadding })
      );
    }
  }]);

  return Carousel;
}(_react2.default.Component);

var SlideType = exports.SlideType = {
  QUOTE: 'Quote',
  WHY_CHOOSE_THIS_TRUST: 'Why choose this trust?',
  VIDEO_WITH_DESCRIPTION: 'Video with description',
  IMAGE_WITH_DESCRIPTION: 'Image with description'
};
exports.default = Carousel;